import axios from "axios";

/**
 * Upload a dish image (file or URL) for a restaurant menu item.
 *
 * @param {File|null} file - Image file from file picker (null if using URL)
 * @param {string|null} imageUrl - External image URL (null if using file)
 * @param {string} restaurantId - Restaurant MongoDB _id
 * @param {number} itemIndex - Index of the menu item in veganOptions
 * @returns {Promise<{displayUrl: string}>}
 */
export async function uploadDishImage(file, imageUrl, restaurantId, itemIndex) {
  const formData = new FormData();
  formData.append("itemIndex", itemIndex);

  if (file) {
    formData.append("image", file);
  } else if (imageUrl) {
    formData.append("imageUrl", imageUrl);
  }

  const res = await axios.post(`/api/images/dish/${restaurantId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

/**
 * Upload a hero image (file or URL) for a restaurant.
 *
 * @param {File|null} file - Image file from file picker
 * @param {string|null} imageUrl - External image URL
 * @param {string} restaurantId - Restaurant MongoDB _id
 * @returns {Promise<{displayUrl: string}>}
 */
export async function uploadHeroImage(file, imageUrl, restaurantId) {
  const formData = new FormData();

  if (file) {
    formData.append("image", file);
  } else if (imageUrl) {
    formData.append("imageUrl", imageUrl);
  }

  const res = await axios.post(`/api/images/hero/${restaurantId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
